import { render, staticRenderFns } from "./UiSidebar.vue?vue&type=template&id=3c8ed1bc&lang=pug&"
import script from "./UiSidebar.vue?vue&type=script&lang=js&"
export * from "./UiSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports